var map = {
	"./best-app-development-tool.md": [
		8821,
		821
	],
	"./common-misconceptions-about-payment.md": [
		3643,
		643
	],
	"./things-to-know-about-startup-business.md": [
		9027,
		27
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2834;
module.exports = webpackAsyncContext;